import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import {
  Controls,
  GetControlsInAccountForComplianceFrameworkRequest,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'

export const useControlsInAccountForComplianceFramework = (
  complianceFrameworkId: string,
  shouldFetch = true,
): GrpcResponse<Controls> => {
  const { response } = useSwrImmutableGrpc(
    ModelPromiseClient.prototype.getControlsInAccountForComplianceFramework,
    new GetControlsInAccountForComplianceFrameworkRequest().setComplianceFrameworkId(
      complianceFrameworkId,
    ),
    shouldFetch,
  )
  return NewGrpcResponse(response)
}
